export enum ShopifyPageType {
  // by ShopifyAnalytics.meta.page.pageType
  PRODUCT = 'product', // eg: https://hipperhiker.myshopify.com/products/brown-leather-mens-watch-custom-handle
  COLLECTION = 'collection', // eg: https://hipperhiker.myshopify.com/collections/frontpage/
  HOME = 'home', // eg: https://hipperhiker.myshopify.com/
  SEARCHRESULTS = 'searchresults', // eg: https://hipperhiker.myshopify.com/search?q=a
  // by URL
  CART = 'cart', // eg: https://hipperhiker.myshopify.com/cart
  LOGIN = 'login', // eg: https://hipperhiker.myshopify.com/account/login
  ACCOUNT = 'account', // eg: https://hipperhiker.myshopify.com/account
  // by ShopifyAnalytics.meta.page.path
  CHECKOUT_CONTACT_INFORMATION = 'checkout_contact_information',
  CHECKOUT_PAYMENT = 'checkout_payment',
  CHECKOUT_THANK_YOU = 'checkout_thank_you',
}

interface ShopInfo {
  locale?: string;
  currency?: string;
  shopId?: string;
}

export interface ShopifyCommonInfo extends ShopInfo {
  pageType: ShopifyPageType;
}

export interface IShopifyVariant {
  id: number;
  variantId?: number;
  name: string;
  price: number;
  public_title: string;
  sku: string;
}

export interface ShopifyProductInfo extends ShopifyCommonInfo {
  pageType: ShopifyPageType.PRODUCT;
  product: Partial<{
    productId: number;
    type: string;
    vendor: string;
    variant?: Partial<IShopifyVariant>;
  }>;
}

export interface ShopifyCollectionInfo extends ShopifyCommonInfo {
  pageType: ShopifyPageType.COLLECTION;
  collection: Partial<{
    collectionId: number;
    collectionHandle: string;
  }>;
}

export type ShopifyInfo = ShopifyProductInfo | ShopifyCollectionInfo | ShopifyCommonInfo;
